import React from 'react';
import { Container, Row } from 'reactstrap';
import { Breadcrumbs } from '../../../../AbstractElements';
import BasicCommon from './BasicCommon';

const BasicCardsContainer = () => {
  return (
    <Container fluid={true}>
      <Breadcrumbs pageTitle='Basic Card' parent='Bonus Ui' title='Basic Card' />
      <Row>
        <BasicCommon />
      </Row>
    </Container>
  );
};
export default BasicCardsContainer;
